import { createContext } from "react";

import { useRequiredContext } from "~/tools/use-required-context";

import type { PinnedItemsState } from "./PinnedItemsState";

export interface PinnedItemsContextValue {
	state: PinnedItemsState;
}

const PinnedItemsContext = createContext<null | PinnedItemsContextValue>(null);

export const PinnedItemsContextProvider = PinnedItemsContext.Provider;

export const usePinnedItemsState = (): PinnedItemsState => {
	const { state } = useRequiredContext(PinnedItemsContext, {
		providerName: "PinnedItemsProvider",
	});

	return state;
};
